import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=28f1ab7a&scoped=true"
import script from "./guest.vue?vue&type=script&lang=js"
export * from "./guest.vue?vue&type=script&lang=js"
import style0 from "./guest.vue?vue&type=style&index=0&id=28f1ab7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1ab7a",
  null
  
)

export default component.exports